import React, { Component } from 'react';
import { debounce } from 'lodash';
import { Col, Row } from 'reactstrap';
import * as Moment from 'moment';
import Help from '../HtmlHelpers';
import ListFunctions from '../FunctionsList';
import TableTitle from '../Layout/TableTitle';
import WmReactTableServerSide from '../Layout/WmReactTableServerSide';
export default class PaginationTable extends Component {
  constructor(props) {
    super(props);
    // These 5 methods are required
    this.getAuth = () => {};
    this.getColumns = () => {};
    this.getListApi = () => '';
    this.getParams = () => {};
    this.getStorageName = () => {};
    // ===================================
    this.getTitle = () => '';
    this.getBeforeTable = () => '';
    this.getApiVersion = () => 1;
    this.additionalContent = () => '';
    this.titleButtons = () => '';
    this.getTableClassSettings = () => '';
    this.getTrProps = (state, rowInfo, instance) => ({});
    this.getOptions = () => ({
      auth: this.getAuth(),
      listApi: this.getListApi(),
      apiVersion: this.getApiVersion(),
      params: this.getParams(),
      storageName: this.getStorageName(),
      innerTableRef: this.innerTableRef.current
    });
    this.getContent = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "6",
      xs: "12"
    }, /*#__PURE__*/React.createElement(TableTitle, {
      title: this.getTitle()
    })), /*#__PURE__*/React.createElement(Col, {
      md: "6",
      xs: "12",
      className: "text-right"
    }, this.titleButtons())), this.getBeforeTable(), this.getTable(), this.additionalContent());
    this.hideReset = () => false;
    this.canDownloadCsv = () => false;
    this.getData = async () => {
      const data = await ListFunctions.fetchData(this.getOptions());
      data.reload = this.props.reload;
      this.setState(data);
    };
    this.fetchCsvData = async () => {
      this.setState({
        currentlyDownloading: true
      });
      const options = this.getOptions();
      options.params.show_all = 'true';
      const data = await ListFunctions.fetchData(options);
      const csvContent = await this.buildCSV(data.data);
      await this.openCSV(csvContent);
      await Help.sleep(600);
      this.setState({
        currentlyDownloading: false
      });
    };
    this.buildCSV = data => {
      const columns = this.getColumns();
      const filtered_columns = columns.filter(c => c.show !== false && c.csvShow !== false);
      const headers = filtered_columns.map(c => c.csvHeader || c.Header);
      const fields = filtered_columns.map(c => c.csv_field || c.accessor);
      const csvData = data.map(d => fields.map(c => {
        let value = '';
        if (typeof c !== 'function') {
          const field = (c || '').toString().split('.');
          if (field.length == 1) {
            value = d[field[0]];
          } else if (field.length == 2) {
            value = d[field[0]][field[1]];
          }
          value = value === 0 ? '0' : (value || '').toString();
        }
        return "\"".concat(this.replaceQuotes(value), "\"");
      }).join(',')).join('\n');
      const content = "".concat(headers.join(','), "\n").concat(csvData);
      return "data:text/csv;charset=utf-8,".concat(encodeURIComponent(content));
    };
    this.replaceQuotes = str => str.toString().replace(/\"/g, '""');
    this.getCsvFilename = () => "".concat(this.getTitle(), " - ").concat(new Moment().format('YYYY-MM-DD hh:mm a'), ".csv");
    this.openCSV = csvContent => {
      const link = document.createElement('a');
      link.setAttribute('href', csvContent);
      link.setAttribute('download', this.getCsvFilename());
      document.body.appendChild(link);
      link.click();
    };
    this.getTable = () => {
      if (this.props.reload !== this.state.reload) {
        this.getData();
      }
      return /*#__PURE__*/React.createElement(WmReactTableServerSide, {
        ref: this.tableRef,
        innerRef: this.innerTableRef,
        className: this.getTableClassSettings(),
        pages: this.state.pages,
        data: this.state.data,
        loading: this.state.loading,
        columns: this.getColumns(),
        onFetchData: debounce(this.getData, 500),
        filtered: ListFunctions.getFiltered(this.getStorageName()),
        onFilteredChange: filtered => this.setState(ListFunctions.onFilteredChange(this.getStorageName(), filtered)),
        sorted: ListFunctions.getSorted(this.getStorageName()),
        onSortChange: sorted => ListFunctions.onSortChange(this.getStorageName(), sorted),
        resetFilters: this.hideReset() ? undefined : () => ListFunctions.resetFilters(this.getStorageName(), this.tableRef),
        getTrProps: this.getTrProps,
        downloadCsv: this.fetchCsvData,
        canDownloadCsv: this.canDownloadCsv(),
        currentlyDownloading: this.state.currentlyDownloading
      });
    };
    this.state = {
      loading: true,
      data: [],
      reload: props.reload,
      currentlyDownloading: false
    };
    this.tableRef = React.createRef();
    this.innerTableRef = React.createRef();
  }
  render() {
    return this.getContent();
  }
}